export default "__VITE_ASSET__BlVQaT0P__"